__turbopack_context__.v({
  "description": "Contact-module__zM3Aiq__description",
  "eyebrow": "Contact-module__zM3Aiq__eyebrow",
  "formStage": "Contact-module__zM3Aiq__formStage",
  "hero": "Contact-module__zM3Aiq__hero",
  "heroInner": "Contact-module__zM3Aiq__heroInner",
  "imageField": "Contact-module__zM3Aiq__imageField",
  "intro": "Contact-module__zM3Aiq__intro",
  "introActions": "Contact-module__zM3Aiq__introActions",
  "primaryLink": "Contact-module__zM3Aiq__primaryLink",
  "title": "Contact-module__zM3Aiq__title",
});
